import * as React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InfoOutlined from '@mui/icons-material/InfoOutlined';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/IconButton": IconButton, "@mui/material/Input": Input, "@mui/material/FilledInput": FilledInput, "@mui/material/OutlinedInput": OutlinedInput, "@mui/material/InputLabel": InputLabel, "@mui/material/InputAdornment": InputAdornment, "@mui/material/FormHelperText": FormHelperText, "@mui/material/FormControl": FormControl, "@mui/material/TextField": TextField, "@mui/material/MenuItem": MenuItem, "@mui/icons-material/Visibility": Visibility, "@mui/icons-material/VisibilityOff": VisibilityOff, "@mui/icons-material/InfoOutlined": InfoOutlined } } });
export default ClientProvider;
